import { render } from "./BankAccountSettingView.vue?vue&type=template&id=7bb72ae6"
import script from "./BankAccountSettingView.vue?vue&type=script&lang=js"
export * from "./BankAccountSettingView.vue?vue&type=script&lang=js"

import "./BankAccountSettingView.vue?vue&type=style&index=0&id=7bb72ae6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__